import { Component, OnInit, Input } from '@angular/core';
import { tPrescriptionHeadModel } from 'src/app/models/tPrescriptionHeadModel';
import { tPrescriptionLineModel_withStock } from 'src/app/models/tPrescriptionLineModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { isNullOrUndefined } from 'util';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { tShopService } from 'src/app/services/tShop.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPrescriptionService } from 'src/app/services/tPrescription.service';


@Component({
  selector: 'app-prescription-tag',
  templateUrl: './prescription-tag.component.html',
  styleUrls: ['./prescription-tag.component.css']
})
export class PrescriptionTagComponent implements OnInit {

  TAG = 'PrescriptionTagComponent';

  urlStartingPath = AppSettings.shopAdapter.imagePath;
  picFullPath = this.urlStartingPath+"/assets/img/print/doc_logo.png";

  @Input() header: tPrescriptionHeadModel;
  @Input() line: tPrescriptionLineModel_withStock[];
  @Input() printMode: number;

  onConsultDataList: tConsultHeadModelWithPatientInfo;
  patientTitle_selection;
  patientGender_selection;

  isHidden_Sub1 = false;
  isHidden_Sub2 = false;
  isHidden_Sub3 = false;

  line1: tPrescriptionLineModel_withStock[] = new Array;
  line2: tPrescriptionLineModel_withStock[] = new Array;

  lineSource1: MatTableDataSource<tPrescriptionLineModel_withStock> = new MatTableDataSource<tPrescriptionLineModel_withStock>();
  lineSource2: MatTableDataSource<tPrescriptionLineModel_withStock> = new MatTableDataSource<tPrescriptionLineModel_withStock>();

  p = {
    consultation:{
      clthConsultNumber:"",
      clthTherapistID:"",
      therapistName:"",
      clthDiagonsis:"",
      prescriptionDate:"",
    },
    patient:{
      patientID:"",patientChiName:"",patientSurname:"",gender:""
    },
    pDetails:[]
  };

  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private tOnConsultService: tOnConsultService,
    private dateTimeConvertService: DateTimeConvertService,
    public datepipe: DatePipe,
    private tShopService: tShopService,
    private tPrescriptionService:tPrescriptionService
    ) { }

  ngOnInit() {
    this.getShopInfo(NavigationComponent.selectedShopID.toString());
    this.onConsultDataList = JSON.parse(localStorage.getItem('onConsultModel'));
    this.getOnConsultInfo();

    this.switchUI();
    this.getDrugLabelPrint();
  }

  getDrugLabelPrint(){
    this.tPrescriptionService
    .getDrugLabelPrint(this.header.prescriptionNumber)
    .subscribe(
      x => this.p = x
    );
  }

  getOnConsultInfo() {

    // tslint:disable-next-line:max-line-length
    this.tOnConsultService.getOnConsultInfo(this.onConsultDataList.shopID, this.onConsultDataList.clthConsultNumber).subscribe(data => {

      // this.log.i(this.TAG + ' getOnConsultInfo: ', JSON.stringify(data));
      this.onConsultDataList = data[0];

    });

  }

  shopNameTC=''
  getShopInfo(shopID){
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shopNameTC = res.shopName;
        // this.shopList = res;
        // this.shopName = this.shopList[0].shopName.toString();
        // console.log('shopList = ' + JSON.stringify(res));
        // console.log('shopList = ' + this.shopList[0].shopName.toString());
      },
      err => {
        console.log(err);
      },
    );
  }


  switchUI() {
    if (!isNullOrUndefined(this.header.prescriptionItemType)) {
      const value = this.header.prescriptionItemType;

      if (value === 1) {
        this.isHidden_Sub1 = false;
        this.isHidden_Sub2 = true;
        this.isHidden_Sub3 = true;
      } else if (value === 2) {
        this.isHidden_Sub1 = true;
        this.isHidden_Sub2 = false;
        this.isHidden_Sub3 = true;
      } else if (value === 3) {
        this.isHidden_Sub1 = true;
        this.isHidden_Sub2 = true;
        this.isHidden_Sub3 = false;
      }
    }
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  formatDate(date: Date) {
    const newDate = new Date(date);

    return this.datepipe.transform(date, 'yyyy/MM/dd');
    // return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }

}
